import { api } from "@/lib/api";
import type { OrderState } from "@/lib/procurement";

export interface OzoRequestItemInput {
  radnik_id: string | null; vrsta_ozo_id: string; velicina: string | null;
  kolicina: number; jedinica: "kom" | "par" | "pak";
}
export interface OzoRequestItem extends OzoRequestItemInput {
  id: string; worker_name: string | null; naziv: string; iznad_kvote: boolean;
  razlog_iznad_kvote: string | null; ukljuceno: boolean; zadnje_izdano: string | null;
}
export interface OzoRequest {
  id: string; gradiliste_id: string; site_name: string; poslao_user_id: string; reported_by: string;
  poslano_at: string; stanje: "poslano" | "naruceno" | "djelomicno" | "odbijeno" | "ponisteno";
  odobrio_user_id: string | null; odobreno_at: string | null; razlog_odbijanja: string | null;
  narudzba_id: string | null; narudzba_stanje: OrderState | null; can_approve: boolean; can_cancel: boolean; undo_until: string;
  stavke: OzoRequestItem[];
}
export interface OzoSuggestion {
  vrsta_ozo_id: string; velicina: string | null; zadnje_izdano: string | null;
  iskoristeno_12mj: number; kvota_12mj: number | null;
}
export interface OzoOptions {
  sites: { id: string; naziv: string }[];
  kinds: { id: string; naziv: string; polje_velicine: string | null; kvota_12mj: number | null }[];
  workers: { id: string; ime: string; suggestions: OzoSuggestion[] }[];
  suppliers: { id: string; naziv: string }[]; can_approve: boolean;
  office_stock?: { vrsta_ozo_id: string; naziv: string; velicina: string; stanje: number }[];
}
export interface OzoDecision { id: string; ukljuceno: boolean; razlog_iznad_kvote: string | null }
const root = "/ozo-zahtjevi";
export const ozoRequests = {
  options: async (gradiliste_id?: string, signal?: AbortSignal) => (await api.get<OzoOptions>(`${root}/options`, { params: { gradiliste_id }, signal })).data,
  list: async (gradiliste_id?: string, signal?: AbortSignal) => (await api.get<OzoRequest[]>(root, { params: { gradiliste_id }, signal })).data,
  create: async (gradiliste_id: string, stavke: OzoRequestItemInput[]) => (await api.post<OzoRequest>(root, { gradiliste_id, stavke })).data,
  cancel: async (id: string) => (await api.post<OzoRequest>(`${root}/${id}/ponisti`, {})).data,
  reduce: async (id: string, stavke: OzoDecision[]) => (await api.patch<OzoRequest>(`${root}/${id}`, { stavke })).data,
  reject: async (id: string, razlog: string) => (await api.post<OzoRequest>(`${root}/${id}/odbij`, { razlog })).data,
  order: async (id: string, dobavljac_id: string, okvirni_iznos: string, stavke: OzoDecision[]) => (await api.post<OzoRequest>(`${root}/${id}/naruci`, { dobavljac_id, okvirni_iznos, stavke })).data,
};
export function issueMonth(value: string | null) {
  return value ? `${value.slice(5, 7)}/${value.slice(0, 4)}` : "još nije izdano";
}
